export default "__VITE_ASSET__BSu0IseT__"